<template>
  <div class="content container-fluid">
    <breadcrumb-index :items="breadcrumbs" />

    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Roles & Permissions</h5>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Permission</th>
                <th class="text-center">Super Admin</th>
                <th class="text-center">Admin</th>
                <th class="text-center">Moderator</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="permission in permissions" :key="permission.key">
                <td>{{ permission.label }}</td>
                <td class="text-center">
                  <vue-feather
                    :type="permission.superAdmin ? 'check' : 'x'"
                    :class="permission.superAdmin ? 'text-success' : 'text-muted'"
                    size="18"
                  />
                </td>
                <td class="text-center">
                  <vue-feather
                    :type="permission.admin ? 'check' : 'x'"
                    :class="permission.admin ? 'text-success' : 'text-muted'"
                    size="18"
                  />
                </td>
                <td class="text-center">
                  <vue-feather
                    :type="permission.moderator ? 'check' : 'x'"
                    :class="permission.moderator ? 'text-success' : 'text-muted'"
                    size="18"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'RolesPermissions',
  setup() {
    const breadcrumbs = [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Users', url: '/app/users/list' },
      { title: 'Roles & Permissions', active: true }
    ]

    const permissions = ref([
      { key: 'manage_users', label: 'Manage Users', superAdmin: true, admin: false, moderator: false },
      { key: 'create_exams', label: 'Create Exams', superAdmin: true, admin: true, moderator: false },
      { key: 'edit_exams', label: 'Edit Exams', superAdmin: true, admin: true, moderator: true },
      { key: 'delete_exams', label: 'Delete Exams', superAdmin: true, admin: true, moderator: false },
      { key: 'view_results', label: 'View Results', superAdmin: true, admin: true, moderator: true },
      { key: 'upload_materials', label: 'Upload Materials', superAdmin: true, admin: true, moderator: true },
      { key: 'delete_materials', label: 'Delete Materials', superAdmin: true, admin: true, moderator: false },
      { key: 'manage_settings', label: 'Manage Settings', superAdmin: true, admin: false, moderator: false },
      { key: 'view_reports', label: 'View Reports', superAdmin: true, admin: true, moderator: true }
    ])

    return { breadcrumbs, permissions }
  }
}
</script>
